enum ApiEnvironment {
  V1 = 0,
  V2,
  Strobbo,
  SuperPlanner,
  Beeple,
  Aronia,
}

const ConfigurableExternalEnvironments = [
  {
    label: 'Strobbo',
    value: ApiEnvironment.Strobbo,
  },
  {
    label: 'Beeple',
    value: ApiEnvironment.Beeple,
  },
];

export { ApiEnvironment, ConfigurableExternalEnvironments };
